import { render, staticRenderFns } from "./PromotionComponent-old.vue?vue&type=template&id=04650847"
import script from "./PromotionComponent-old.vue?vue&type=script&lang=js"
export * from "./PromotionComponent-old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports